import React from 'react'
import Icon from '../Icon'
import './social.css'

interface Props {
	social: string,
	url: string
}

const SocialCard: React.FC<Props> = ({ social = '' , url = '' }) => {
	return (
		<a className="_social_link"
			href={url} 
			target="_blank" 
			rel="noopener noreferrer"
		>
			<Icon name={social} />
		</a>
	)
}

export default SocialCard